import axios from 'axios';

import IConvertToLeadDTO from '../types/IConvertToLeadDTO';
import ILead, { LeadStatusDTO } from '../types/ILead';
import ILeadSearchFilter from '../types/ILeadSearchFilter';

const url = '/invoicingservice/api/lead';

const urlForLeadStatus = '/invoicingservice/api/leadstatus';

export const getAllLeads = (leadsFilter: ILeadSearchFilter) =>
  axios.post(`${url}/list`, leadsFilter);

export const saveLead = (leadPayload: ILead) => axios.post(`${url}/add`, leadPayload);

export const getLeadById = (leadId: string) => axios.get(`${url}/get-lead-by-id/${leadId}`);

export const updateLeadStatus = (lead: ILead) => axios.put(`${url}/update-status`, lead);

export const updateLeadOwner = (lead: ILead) => axios.put(`${url}/update-lead-owner`, lead);

export const getLeadStatusList = () => axios.get(`${urlForLeadStatus}/get-all-lead-status`);

export const saveLeadStatus = (leadStatus: LeadStatusDTO) =>
  axios.post(`${urlForLeadStatus}/create-lead-status`, leadStatus);

export const getAllLeadStatusByVisibility = () =>
  axios.get(`${urlForLeadStatus}/get-all-lead-status-by-visibility`);

export const getAllLeadTags = () => axios.get(`${url}/tags`);

export const getAllActiveLeadStatus = () => axios.get(`${urlForLeadStatus}/lead-status`);

export const convertCrmJobToLead = (crmJobToLeadDto: IConvertToLeadDTO) =>
  axios.post(`${url}/crmjob-to-lead`, crmJobToLeadDto);
